<template>
  <router-link class="lin-teaser" :to="local('/lineage')">
    <span class="lin-teaser-thumbs" aria-hidden="true"><img v-for="f in teaser.founders" :key="f.id" :src="f.img" alt="" loading="lazy" width="132" height="92" /></span>
    <span class="lin-teaser-text">
      <span class="lin-teaser-kicker">{{ zh ? '創作族譜' : 'Family tree' }}</span>
      <strong>{{ zh ? `${teaser.counts.nodes} 件每日創作，怎麼一件長出一件` : `How ${teaser.counts.nodes} daily sketches grew out of one another` }}</strong>
      <span class="lin-teaser-sub">{{ zh ? `${teaser.counts.families} 個家族畫成有縮圖的分支樹，從 2018 到 2026` : `${teaser.counts.families} families drawn as branching trees with thumbnails, 2018 to 2026` }}</span>
    </span>
    <span class="lin-teaser-arrow" aria-hidden="true">→</span>
  </router-link>
</template>

<script setup>
import { withSlash } from '@/runtime/site-path.mjs'
// 只吃 lineage-teaser.json（幾 KB），不把整份族譜資料拖進 lab／work 的 bundle
import teaser from '@/data/lineage-teaser.json'
const props = defineProps({ zh: Boolean })
const local = p => withSlash((props.zh ? '/zh' : '') + p)
</script>

<style>
.lin-teaser{display:grid;grid-template-columns:auto 1fr auto;gap:22px;align-items:center;padding:18px 22px;border:0;border-radius:var(--r-lg);color:var(--ink);text-decoration:none;background:var(--bg1);transition:var(--t-hover)}
.lin-teaser:hover{background:var(--bg2);color:var(--ink);text-decoration:none}
.lin-teaser:hover strong{color:var(--gold)}
.lin-teaser-thumbs{display:grid;grid-template-columns:repeat(4,44px);gap:3px}
.lin-teaser-thumbs img{display:block;width:44px;height:31px;object-fit:cover;background:var(--bg2)}
.lin-teaser-text{display:grid;gap:3px;min-width:0}
.lin-teaser-kicker{font-size:.7rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-3,#85858a)}
.lin-teaser strong{font-family:var(--font-display,Georgia,serif);font-weight:500;font-size:1.05rem;line-height:1.35}
.lin-teaser-sub{font-size:.82rem;color:var(--ink-2,#b4b4b0)}
.lin-teaser-arrow{color:var(--gold,#d9c267);font-size:1.2rem}
@media(max-width:575px){.lin-teaser{grid-template-columns:1fr auto}.lin-teaser-thumbs{display:none}}
</style>
